import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { publicApi } from '../api/insolita';
import { useUi } from '../i18n/ui';

const STATUS_KEY: Record<string, { title: string; text: string }> = {
  CONFIRMED: { title: 'bo.confirmed.title', text: 'bo.confirmed.text' },
  WAITLISTED: { title: 'bo.waitlisted.title', text: 'bo.waitlisted.text' },
  CANCELLED: { title: 'bo.cancelled.title', text: 'bo.cancelled.text' },
  PENDING: { title: 'bo.pending.title', text: 'bo.pending.text' },
};

const BookingOutcome: React.FC<{ mode: 'confirm' | 'cancel' }> = ({ mode }) => {
  const { tr } = useUi();
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) { setError(tr('bo.invalid')); setLoading(false); return; }
    const call = mode === 'confirm' ? publicApi.confirmBooking(token) : publicApi.cancelBooking(token);
    call
      .then((s) => setStatus(s))
      .catch((err) => setError(err?.response?.data?.message || tr('bo.error.text')))
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, mode]);

  const entry = status ? STATUS_KEY[status] : undefined;
  const title = loading ? tr('bo.loading.title') : error ? tr('bo.error.title') : (entry ? tr(entry.title) : 'Fatto');
  const text = loading ? tr('bo.loading.text') : error ? error : (entry ? tr(entry.text) : '');

  return (
    <section className="phero" style={{ minHeight: '70svh' }}>
      <div className="phero__bg"><img src="/img/insolita-sardegna-experience.jpg" alt="Insolita Sardegna" /></div>
      <div className="phero__inner">
        <div className="phero__crumb"><Link to="/">{tr('crumb.home')}</Link> <span className="acc">/</span> {tr('crumb.prenotazione')}</div>
        <h1 style={{ marginBottom: '.4em' }}>{title}</h1>
        <p className="hero__sub">{text}</p>
        <div className="hero__cta">
          <Link to="/tour" className="btn btn-acid">{tr('bo.back.tour')}</Link>
          <Link to="/" className="btn btn-ghost">{tr('bo.back.home')}</Link>
        </div>
      </div>
    </section>
  );
};

export default BookingOutcome;
